import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Πολιτική Απορρήτου Nalumer | Προστασία Δεδομένων</title>
        <meta name="description" content="Διαβάστε την πολιτική απορρήτου του Nalumer: πώς συλλέγουμε, χρησιμοποιούμε και προστατεύουμε τα προσωπικά σας δεδομένα σύμφωνα με την ισχύουσα νομοθεσία." />
      </Helmet>

      <div className="policy-container">
      <div className="policy-content">
        <h1>Πολιτική Απορρήτου</h1>
        <p className="last-updated">Τελευταία ενημέρωση: {new Date().toLocaleDateString('el-GR')}</p>

        <section>
          <h2>1. Εισαγωγή</h2>
          <p>
            Καλώς ήρθατε στο Nalumer. Σεβόμαστε το απόρρητό σας και δεσμευόμαστε να προστατεύουμε 
            τα προσωπικά σας δεδομένα. Αυτή η πολιτική απορρήτου θα σας ενημερώσει για το πώς 
            φροντίζουμε τα προσωπικά σας δεδομένα όταν επισκέπτεστε τον ιστότοπό μας και θα σας 
            ενημερώσει για τα δικαιώματά σας περί απορρήτου.
          </p>
        </section>

        <section>
          <h2>2. Δεδομένα που Συλλέγουμε</h2>
          <p>Μπορούμε να συλλέξουμε, να χρησιμοποιήσουμε, να αποθηκεύσουμε και να μεταφέρουμε διαφορετικά είδη προσωπικών δεδομένων σχετικά με εσάς:</p>
          <ul>
            <li><strong>Δεδομένα Ταυτότητας:</strong> όνομα, επώνυμο, ημερομηνία γέννησης</li>
            <li><strong>Δεδομένα Επικοινωνίας:</strong> διεύθυνση email, αριθμοί τηλεφώνου, διεύθυνση παράδοσης</li>
            <li><strong>Οικονομικά Δεδομένα:</strong> στοιχεία τραπεζικού λογαριασμού και κάρτας πληρωμής</li>
            <li><strong>Δεδομένα Συναλλαγών:</strong> λεπτομέρειες σχετικά με τις παραγγελίες και τις πληρωμές σας</li>
            <li><strong>Τεχνικά Δεδομένα:</strong> διεύθυνση IP, τύπος και έκδοση προγράμματος περιήγησης, ρυθμίσεις ζώνης ώρας</li>
            <li><strong>Δεδομένα Χρήσης:</strong> πληροφορίες σχετικά με τον τρόπο χρήσης του ιστότοπού μας</li>
          </ul>
        </section>

        <section>
          <h2>3. Πώς Χρησιμοποιούμε τα Δεδομένα σας</h2>
          <p>Χρησιμοποιούμε τα δεδομένά σας για τους ακόλουθους σκοπούς:</p>
          <ul>
            <li>Για την εκτέλεση των παραγγελιών σας και την παροχή υπηρεσιών catering</li>
            <li>Για την επεξεργασία και την παράδοση των παραγγελιών σας</li>
            <li>Για τη διαχείριση των πληρωμών, των τελών και των χρεώσεων</li>
            <li>Για την επικοινωνία μαζί σας σχετικά με τις παραγγελίες σας</li>
            <li>Για να σας ενημερώνουμε για νέες υπηρεσίες και προσφορές</li>
            <li>Για τη βελτίωση των υπηρεσιών και του ιστότοπού μας</li>
            <li>Για την προστασία από απάτες και την ασφάλεια του ιστότοπου</li>
          </ul>
        </section>

        <section>
          <h2>4. Κοινοποίηση Δεδομένων</h2>
          <p>
            Μπορεί να μοιραστούμε τα προσωπικά σας δεδομένα με τρίτους μόνο στις ακόλουθες περιπτώσεις:
          </p>
          <ul>
            <li>Με παρόχους υπηρεσιών που μας βοηθούν στην εκτέλεση παραγγελιών (π.χ. εταιρείες μεταφορών)</li>
            <li>Με επεξεργαστές πληρωμών για την ασφαλή επεξεργασία συναλλαγών</li>
            <li>Με επαγγελματίες συμβούλους (λογιστές, δικηγόρους)</li>
            <li>Όταν απαιτείται από το νόμο ή για την προστασία των δικαιωμάτων μας</li>
          </ul>
        </section>

        <section>
          <h2>5. Ασφάλεια Δεδομένων</h2>
          <p>
            Έχουμε θέσει σε εφαρμογή κατάλληλα μέτρα ασφαλείας για να αποτρέψουμε την τυχαία απώλεια, 
            τη χρήση ή την πρόσβαση με μη εξουσιοδοτημένο τρόπο, την αλλοίωση ή τη γνωστοποίηση των 
            προσωπικών σας δεδομένων. Χρησιμοποιούμε κρυπτογράφηση SSL για την προστασία των 
            ευαίσθητων πληροφοριών κατά τη μετάδοση.
          </p>
        </section>

        <section>
          <h2>6. Διατήρηση Δεδομένων</h2>
          <p>
            Θα διατηρήσουμε τα προσωπικά σας δεδομένα μόνο για όσο διάστημα είναι αναγκαίο για την 
            εκπλήρωση των σκοπών για τους οποίους τα συλλέξαμε, συμπεριλαμβανομένων των σκοπών 
            ικανοποίησης τυχόν νομικών, λογιστικών ή απαιτήσεων αναφοράς.
          </p>
        </section>

        <section>
          <h2>7. Τα Δικαιώματά σας</h2>
          <p>Σύμφωνα με τον ΓΚΠΔ, έχετε τα ακόλουθα δικαιώματα:</p>
          <ul>
            <li><strong>Δικαίωμα πρόσβασης:</strong> Να ζητήσετε αντίγραφα των προσωπικών σας δεδομένων</li>
            <li><strong>Δικαίωμα διόρθωσης:</strong> Να ζητήσετε τη διόρθωση ανακριβών δεδομένων</li>
            <li><strong>Δικαίωμα διαγραφής:</strong> Να ζητήσετε τη διαγραφή των προσωπικών σας δεδομένων</li>
            <li><strong>Δικαίωμα περιορισμού:</strong> Να ζητήσετε τον περιορισμό της επεξεργασίας</li>
            <li><strong>Δικαίωμα φορητότητας:</strong> Να λάβετε τα δεδομένα σε δομημένη μορφή</li>
            <li><strong>Δικαίωμα εναντίωσης:</strong> Να αντιταχθείτε στην επεξεργασία των δεδομένων σας</li>
          </ul>
        </section>

        <section>
          <h2>8. Cookies</h2>
          <p>
            Ο ιστότοπός μας χρησιμοποιεί cookies για να διακρίνει τον χρήστη από άλλους χρήστες του 
            ιστότοπού μας. Αυτό μας βοηθά να σας παρέχουμε μια καλή εμπειρία όταν περιηγείστε στον 
            ιστότοπό μας και επίσης μας επιτρέπει να βελτιώσουμε τον ιστότοπό μας. Χρησιμοποιούμε 
            Google Analytics και Facebook Pixel για την ανάλυση της χρήσης του ιστότοπου.
          </p>
        </section>

        <section>
          <h2>9. Σύνδεσμοι Τρίτων</h2>
          <p>
            Ο ιστότοπός μας μπορεί να περιέχει συνδέσμους προς ιστότοπους τρίτων. Εάν ακολουθήσετε 
            έναν σύνδεσμο σε οποιονδήποτε από αυτούς τους ιστότοπους, σημειώστε ότι αυτοί οι 
            ιστότοποι έχουν τις δικές τους πολιτικές απορρήτου και δεν αποδεχόμαστε καμία ευθύνη 
            ή υποχρέωση για αυτές τις πολιτικές.
          </p>
        </section>

        <section>
          <h2>10. Αλλαγές στην Πολιτική Απορρήτου</h2>
          <p>
            Μπορεί να ενημερώνουμε την πολιτική απορρήτου κατά καιρούς. Θα σας ειδοποιήσουμε για 
            τυχόν αλλαγές δημοσιεύοντας τη νέα πολιτική απορρήτου σε αυτήν τη σελίδα και 
            ενημερώνοντας την ημερομηνία "Τελευταία ενημέρωση" στην κορυφή αυτής της πολιτικής.
          </p>
        </section>

        <section>
          <h2>11. Επικοινωνία</h2>
          <p>
            Εάν έχετε οποιεσδήποτε ερωτήσεις σχετικά με αυτήν την πολιτική απορρήτου ή τις 
            πρακτικές απορρήτου μας, παρακαλούμε επικοινωνήστε μαζί μας:
          </p>
          <ul>
            <li>Email: <a href="mailto:nalumer@hotmail.com">nalumer@hotmail.com</a></li>
            <li>Τηλέφωνο: +30 210 1234567</li>
            <li>Διεύθυνση: Αθήνα, Ελλάδα</li>
          </ul>
        </section>

        <section>
          <h2>12. Αρχή Προστασίας Δεδομένων</h2>
          <p>
            Έχετε επίσης το δικαίωμα να υποβάλετε καταγγελία στην Αρχή Προστασίας Δεδομένων 
            Προσωπικού Χαρακτήρα εάν θεωρείτε ότι η επεξεργασία των προσωπικών σας δεδομένων 
            παραβιάζει τον ΓΚΠΔ.
          </p>
          <p>
            Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα<br />
            Ιφιγενείας 1-3, 11522 Αθήνα<br />
            Τηλ: +30 210 6475600<br />
            Email: <a href="mailto:nalumer@hotmail.com">nalumer@hotmail.com</a>
          </p>
        </section>
      </div>
    </div>
  
    </>);
};

export default PrivacyPolicy;